import { MenuItem, TextField } from "@mui/material";
import React, { ChangeEvent } from "react";

interface IDropdown {
  id: string;
  entries: string[];
  selected: string;
  label: string;
  onChange: (active: string) => void;
}

const Dropdown: React.FC<IDropdown> = (props) => {

  function onEntryClicked(event: ChangeEvent<HTMLInputElement>) {
    props.onChange(event.target.value);
  }

  return (
  <TextField select className="w-full" id={props.id} label={props.label} value={props.selected} onChange={onEntryClicked}>
      {props.entries.map((entry, idx) => {
        return <MenuItem key={`${entry}_${idx}`} value={entry}>{entry}</MenuItem>;
      })}
  </TextField>)
}

export default Dropdown;
